import { createRequestActions } from '../utils';
import * as CpsrChaptersTypes from './cpsrChaptersTypes';

export const listCpsrChapter = createRequestActions(CpsrChaptersTypes.CPSR_CHAPTER_LIST);
